//Please try not to change the variable names.
//If you do, you must update Octopus Deploy so it replaces the variable name properly.
export default {
    apiUrl: "#{ApiUrl}",
    appInsightInstrumentationKey: "#{AppInsightInstrumentationKey}",
    authApiUrl: "#{AuthApiUrl}",
    authUiUrl: "#{AuthUiUrl}",
    cdnUrl: "#{CDNUrl}",
    clientId: "#{DefaultClientId}",
    googleMapsApiKey: "#{GoogleMapsApiKey}",
    hotjarId: "#{hotjarId}",
    northBaseUrl: '#{NorthBaseUrl}',
    productTrackingUrl: '#{productTrackingUrl}',
    supportInfo: {
        email: "#{NcontractsSupportEmail}",
        phone: "#{NcontractsSupportPhone}"
    },
};
